module.exports = __webpack_public_path__ + "img/vertical_4_1_8019.3851e18b.png";